import React from "react";
import { GridLoader } from "react-spinners";

const Loader = () => {
  return (
    <div>
      <GridLoader color="#36d7b7" />
    </div>
  );
};

export default Loader;
